import { CHANNEL_ID } from '@@types/common';

export enum WinNativeFocusTarget {
  POPUP = 'popup',
  ORG_CHART = 'orgChart',
  INTEGRATION = 'integration',
}

export interface WinNativeSetFocusContents {
  channelId?: CHANNEL_ID;
  target: WinNativeFocusTarget;
}

export interface WinNativeSetPopupFocusContents extends WinNativeSetFocusContents {
  target: WinNativeFocusTarget.POPUP;
  channelId: string;
}
